'use client';

import ArrowDownGray106 from '@svg/common/arrow_down_gray_10_6.svg';
import { useEffect, useRef, useState } from 'react';

export default function SelectBoxSmall({
  items,
  placeholder,
  selectedItem,
  setSelectedItem,
}: {
  items: string[];
  placeholder: string;
  selectedItem: string | null;
  setSelectedItem: React.Dispatch<React.SetStateAction<string | null>>;
}) {
  const selectBoxRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (selectBoxRef.current && !selectBoxRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className='relative z-10' ref={selectBoxRef}>
      <button
        className={`w-full py-9pxr pl-14pxr pr-8pxr flex items-center justify-between bg-white rounded-8pxr ${
          isOpen ? 'ring-1 ring-new-point-500' : 'ring-1 ring-new-gray-300'
        }`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <span className='body-14-regular text-new-gray-900'>{selectedItem || placeholder}</span>
        <span
          className={`w-16pxr h-16pxr flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        >
          <ArrowDownGray106 />
        </span>
      </button>
      {isOpen && (
        <div
          className='absolute w-full h-224pxr rounded-8pxr bg-white border border-new-gray-300 translate-y-8pxr overflow-y-scroll apple-scrollbar'
          style={{
            boxShadow: '0px 4px 8px 0px rgba(14, 31, 53, 0.12)',
          }}
        >
          <button
            className='w-full h-38pxr flex items-center px-16pxr py-9pxr bg-white hover:bg-new-point-100 body-14-regular text-new-gray-900'
            onClick={() => {
              setSelectedItem(null);
              setIsOpen(false);
            }}
          >
            {placeholder}
          </button>
          {items.map((item) => (
            <button
              key={item}
              className='w-full h-38pxr flex items-center px-16pxr py-9pxr bg-white hover:bg-new-point-100 body-14-regular text-new-gray-900'
              onClick={() => {
                setSelectedItem(item);
                setIsOpen(false);
              }}
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
